import React from "react";
import Layout from "../../../components/common/layout";
import Settings from "../../Main/settings/services";

const AddDeal = () => {
  return (
    <>
      <Layout
        heading="Service Pricing"
        isAddDeals
        curr={3}
        page={<Settings isSetupPage={true} />}
      />
    </>
  );
};

export default AddDeal;
